import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const SampleTestsRoutes: RouteBundle = {
  domain: 'sample_tests',
  routes: [
    {
      urlPattern: 'test-definitions/listing',
      handler: EditorRoutes.testDefinitions.bind(EditorRoutes),
    },
    {
      urlPattern: 'test-definitions/create',
      handler: EditorRoutes.testDefinitionCreate.bind(EditorRoutes),
    },
    {
      urlPattern: 'test-definitions/:id',
      handler: EditorRoutes.testDefinition.bind(EditorRoutes),
    },
  ],
};
